import { InboxOutlined } from '@ant-design/icons';
import { Button, Col, Modal, Row, Select, Upload } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { allowedFileCriteria } from '../../../utils/fileUtils';

const { Option } = Select;

const UploadConsentModal = ({
  visible,
  closeModal,
  reservationList,
  uploadFunction
}) => {
  const { t } = useTranslation();
  const [consent, setConsent] = useState();
  const [admissionPatientId, setAdmissionPatientId] = useState("");
  const [consentType, setConsentType] = useState("");
  const [loading, setLoading] = useState({ upload: false });

  const loadConsent = (file) => {
    if (allowedFileCriteria(t, file, 2)) {
      setConsent(file);
    }
  }

  const uploadConsent = () => uploadFunction(admissionPatientId, consentType, consent, setLoading, null)

  return (
    <Modal
      visible={visible}
      centered
      footer={false}
      closable
      onCancel={closeModal}
      className='webcam-modal'
      width={800}
      responsive
      destroyOnClose
    >
      <div className='pt-90 pl-100 pr-100'>
        <Upload.Dragger
          maxCount={1}
          fileList={consent ? [consent] : []}
          onRemove={() => {
            setConsent(undefined);
          }}
          beforeUpload={file => {
            loadConsent(file);
            return false;
          }}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined style={{ fontSize: 76, color: "#BEBEBE" }} />
          </p>
          <p className="ant-upload-text mb-20" style={{ color: "#DC582A" }}><strong>{t("patientPage.consentDetail.modalFileInstruction")}</strong></p>
          <p className="ant-upload-hint mb-20">
            {t("patientPage.consentDetail.modalFileRestriction")}
          </p>
        </Upload.Dragger>
        <Row justify="center" className='mt-40 mb-30'>
          <div className='fill-data-text'>{t("patientPage.consentDetail.modalDataInstruction")}</div>
        </Row>
        <Row justify="space-around">
          <Col lg={10} xs={24}>
            <Select
              className="cmt-select"
              style={{ width: "100%" }}
              placeholder={t("patientPage.consentDetail.modalReservationPlaceholder")}
              size="large"
              showSearch
              notFoundContent={<div>{t("patientPage.consentDetail.modalNoReservation")}</div>}
              options={reservationList}
              onChange={(value) => setAdmissionPatientId(value)}
            />
          </Col>
          <Col lg={10} xs={24}>
            <Select
              size="large"
              className='cmt-select'
              style={{ width: "100%" }}
              placeholder="Tipo de consentimiento"
              onChange={(value) => setConsentType(value)}
            >
              <Option value="normal">
                {t("patientPage.consentDetail.normalType")}
              </Option>
              <Option value="psychological">
                {t("patientPage.consentDetail.psychologicalType")}
              </Option>
              <Option value="drugs">
                {t("patientPage.consentDetail.drugsType")}
              </Option>
              <Option value="stopBang">
                {t("patientPage.consentDetail.stopBangType")}
              </Option>
              <Option value="isl">
                {t("patientPage.consentDetail.islType")}
              </Option>
              <Option value="other">
                {t("patientPage.consentDetail.othersType")}
              </Option>
            </Select>
          </Col>
        </Row>
        <Row justify="center" className='mt-40 mb-30'>
          <div>
            <Button
              className={`cmt-button ${(!consent || !admissionPatientId || !consentType) ? "disabled" : "primary"} 
                          pl-70 pr-70`}
              type="primary"
              loading={loading.upload}
              onClick={uploadConsent}
              disabled={!consent || !admissionPatientId || !consentType}
              size="large">
              {t("patientPage.consentDetail.modalSaveButton")}
            </Button>
          </div>
        </Row>
      </div>
    </Modal>
  )
};

export default UploadConsentModal;